import { render, staticRenderFns } from "./DeliveryPrepare.vue?vue&type=template&id=44cefa80&scoped=true&"
import script from "./DeliveryPrepare.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPrepare.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryPrepare.vue?vue&type=style&index=0&id=44cefa80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cefa80",
  null
  
)

export default component.exports